import { render, staticRenderFns } from "./PrmClue.vue?vue&type=template&id=605e24e6&scoped=true&"
import script from "./PrmClue.vue?vue&type=script&lang=js&"
export * from "./PrmClue.vue?vue&type=script&lang=js&"
import style0 from "./PrmClue.vue?vue&type=style&index=0&id=605e24e6&scoped=true&lang=scss&"
import style1 from "./PrmClue.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605e24e6",
  null
  
)

component.options.__file = "PrmClue.vue"
export default component.exports